const grey = {
  900: '#0b0c0d',
  // $color-banner-black-01-dark  | common.black
  800: '#303235',
  // $color-banner-black          | text.primary
  700: '#56595d',
  // $color-banner-black-03-light
  600: '#7b7f84',
  // $color-banner-black-04-light | text.disabled
  500: '#9ca0a5',
  // $color-banner-black-05-light
  400: '#b8bbbf',
  // $color-banner-black-06-light
  300: '#cfd1d3',
  // $color-banner-black-07-light
  200: '#e1e1e2',
  // $color-banner-black-08-light
  100: '#ededee',
  // $color-banner-black-09-light
  50: '#f5f5f5',
  //  $color-banner-black-10-light
  25: '#fafafa' //  $color-banner-black-11-light
};

export default grey;